import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

class SideBox extends Component {



  render() {
    return (
        <div className="sidebox">
	        <h4>{ReactHtmlParser(this.props.title)}</h4>
            <div className="sidebox-content">
                {this.props.children}
            </div>
        </div>
    );
  }
}

export default SideBox;




// WEBPACK FOOTER //
// ./src/components/SideBox/SideBox.js